(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2521],{

/***/ 55247:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(61984);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _buttons_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21489);




var ViewDealsButton = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        className: "flex items-center py-2",
        href: "/deals",
        passHref: true,
        legacyBehavior: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_buttons_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
            classes: "my-6",
            size: _buttons_Button__WEBPACK_IMPORTED_MODULE_3__/* .ButtonSize.primary */ .qE.primary,
            type: _buttons_Button__WEBPACK_IMPORTED_MODULE_3__/* .ButtonType.primary */ .L$.primary,
            children: "Explore Opportunities"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ViewDealsButton);


/***/ }),

/***/ 637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);



var SeoHead = function(param) {
    var title = param.title, description = param.description, imageURI = param.imageURI, pagePath = param.pagePath, twitterTitle = param.twitterTitle, twitterDescription = param.twitterDescription;
    var defaultDescription = description !== null && description !== void 0 ? description : "Most people don’t have the resources, time, or connections to truly use their web3 IP. Our goal at OverpassIP is to provide holders with easily accessible opportunities to leverage their NFTs IP. With OverpassIP, the web3 user will seamlessly connect with the Web2 brand. Join us in revolutionizing IP functionality for years to come.";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "shortcut icon",
                type: "image/svg+xml",
                href: "/overpass.svg"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: defaultDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: imageURI ? imageURI : "/img/OverPassCover.png"
            }, "ogimage"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }, "ogtitle"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: defaultDescription
            }, "ogdesc"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: pagePath !== null && pagePath !== void 0 ? pagePath : "/"
            }, "ogurl"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@OverpassIP"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: "@OverpassIP"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: twitterTitle ? twitterTitle : title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: twitterDescription ? twitterDescription : defaultDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: imageURI ? imageURI : "/img/OverPassCover.png"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoHead);


/***/ }),

/***/ 56245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "kJ": function() { return /* binding */ ArrowButtonStyle; },
  "n4": function() { return /* binding */ ArrowDirection; },
  "ZP": function() { return /* binding */ navigation_ArrowButton; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./components/svg/LeftNavArrow.tsx


var LeftNavArrow = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#8490FF" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1344_798)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M19 12L5 12",
                        stroke: fill,
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11 6L5 12",
                        stroke: fill,
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11 18L5 12",
                        stroke: fill,
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1344_798",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white",
                        transform: "translate(24 24) rotate(-180)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var svg_LeftNavArrow = (LeftNavArrow);

;// CONCATENATED MODULE: ./components/navigation/ArrowButton.tsx



var ArrowDirection;
(function(ArrowDirection) {
    ArrowDirection["left"] = "rotate-0";
    ArrowDirection["right"] = "rotate-180";
    ArrowDirection["up"] = "rotate-90";
    ArrowDirection["down"] = "-rotate-90";
})(ArrowDirection || (ArrowDirection = {}));
var ArrowButtonStyle;
(function(ArrowButtonStyle) {
    ArrowButtonStyle["default"] = "flex rounded-full w-10 h-10 bg-white active:bg-primary-pressed";
    ArrowButtonStyle["dark"] = "flex rounded-full w-10 h-10 font-white bg-primary-main active:bg-primary-pressed";
    ArrowButtonStyle["border"] = "flex rounded-full w-10 h-10 border-primary-main border-[1px] bg-white";
})(ArrowButtonStyle || (ArrowButtonStyle = {}));
var ArrowButton = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var _direction = param.direction, direction = _direction === void 0 ? ArrowDirection.left : _direction, classes = param.classes, _style = param.style, style = _style === void 0 ? ArrowButtonStyle.default : _style;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        ref: ref,
        className: "".concat(style, " flex-shrink-0"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex w-full place-content-center items-center self-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: direction,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg_LeftNavArrow, {
                    classes: classes,
                    fill: style === ArrowButtonStyle.dark ? "#fff" : "#8490FF"
                })
            })
        })
    });
});
ArrowButton.displayName = "ArrowButton";
/* harmony default export */ var navigation_ArrowButton = (ArrowButton);


/***/ }),

/***/ 7414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ usePageEntrance; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74682);
/* harmony import */ var _app_config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31470);
/* harmony import */ var _app_config_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_app_config_js__WEBPACK_IMPORTED_MODULE_1__);
/* eslint-disable */ 


var usePageEntrance = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), once = ref[0], setOnce = ref[1];
    var onceVar = false;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (once || onceVar) {
            return;
        }
        setOnce(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        onceVar = true;
        // @ts-ignore
        var timeline = new gsap__WEBPACK_IMPORTED_MODULE_2__/* .gsap.timeline */ .p8.timeline();
        var int = setInterval(function() {
            if ((_app_config_js__WEBPACK_IMPORTED_MODULE_1___default().transitionFinished)) {
                clearInterval(int);
                var enterEls = document.querySelectorAll(".enter-el, .enter-el-block, .enter-el-inherit");
                timeline.fromTo(enterEls, {
                    y: 40
                }, {
                    y: 0,
                    stagger: .07,
                    force3D: true,
                    duration: 1.4,
                    ease: "expo.out"
                }).fromTo(enterEls, {
                    opacity: 0
                }, {
                    opacity: 1,
                    stagger: .07,
                    force3D: true,
                    duration: 1.35,
                    ease: "expo.out"
                }, 0.05);
            }
        });
    });
};


/***/ }),

/***/ 61984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ about; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/head/SeoHead.tsx
var SeoHead = __webpack_require__(637);
// EXTERNAL MODULE: ./components/navigation/ArrowButton.tsx + 1 modules
var ArrowButton = __webpack_require__(56245);
;// CONCATENATED MODULE: ./components/UI/Hero.tsx



var HeroSection = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative z-[1] flex h-[calc(100dvh)] flex-col items-center justify-center pb-[50px]",
        children: children
    });
};
var ContentSection = function(param) {
    var children = param.children;
    // calculating iconOffset not working on deployed instance, will investigate but pushing to avoid blocking dev
    var ref = (0,react.useState)(20), setIconOffset = ref[1];
    var handleClick = function(value) {
        var element = document.getElementById(value);
        element === null || element === void 0 ? void 0 : element.scrollIntoView({
            behavior: "smooth"
        });
    };
    (0,react.useEffect)(function() {
        var ref;
        // Recalculating height to ensure we're always updating half of the icon height if the height changes
        var iconHeight = (ref = document.getElementById("icon")) === null || ref === void 0 ? void 0 : ref.offsetHeight;
        setIconOffset((iconHeight !== null && iconHeight !== void 0 ? iconHeight : 40) / 2);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative z-[2] mx-auto -mt-[37px] flex w-full flex-col items-center justify-center rounded-t-3xl bg-white",
        id: "content",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "-mt-[20px] justify-center",
                onClick: function() {
                    return handleClick("content");
                },
                id: "icon",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowButton/* default */.ZP, {
                    direction: ArrowButton/* ArrowDirection.down */.n4.down,
                    style: ArrowButton/* ArrowButtonStyle.dark */.kJ.dark,
                    classes: "mx-auto"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full pt-[100px]",
                children: children
            })
        ]
    });
};
var HeroComponent = function(param) {
    var heroSection = param.heroSection, content = param.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "top-0 w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSection, {
                children: heroSection
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSection, {
                children: content
            })
        ]
    });
};
/* harmony default export */ var Hero = (HeroComponent);

// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ./components/UI/Pill.tsx
var Pill = __webpack_require__(50850);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion.mjs + 182 modules
var motion = __webpack_require__(36830);
;// CONCATENATED MODULE: ./framer/cardVariants.ts
var cardVariants = {
    offscreen: {
        scale: 0.9,
        opacity: 0
    },
    onscreen: {
        scale: 1,
        opacity: 1,
        transition: {
            type: "spring",
            bounce: 0.2,
            duration: 1
        }
    }
};
var cardVariantsNoScale = {
    offscreen: {
        opacity: 0
    },
    onscreen: {
        opacity: 1,
        transition: {
            type: "spring",
            bounce: 0.2,
            duration: 1
        }
    }
};
var cardVariantsNoOpacityFullScale = {
    offscreen: {
        scale: 0
    },
    onscreen: {
        scale: 1,
        transition: {
            type: "spring",
            bounce: 0.2,
            duration: 1
        }
    }
};

;// CONCATENATED MODULE: ./framer/animateWhileInView/whileInView.ts
var whileInView10once = {
    initial: "offscreen",
    whileInView: "onscreen",
    viewport: {
        once: true,
        amount: 0.1
    }
};
var whileInView30once = {
    initial: "offscreen",
    whileInView: "onscreen",
    viewport: {
        once: true,
        amount: 0.3
    }
};
var whileInView100once = {
    initial: "offscreen",
    whileInView: "onscreen",
    viewport: {
        once: true,
        amount: 1
    }
};

;// CONCATENATED MODULE: ./framer/animateWhileInView/ScrollMotion100Once.tsx







var ScrollMotion100Once = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, whileInView100once), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
            variants: cardVariants,
            children: children
        })
    }));
};
/* harmony default export */ var animateWhileInView_ScrollMotion100Once = (ScrollMotion100Once);

// EXTERNAL MODULE: ./hooks/useWindowSize.tsx + 1 modules
var useWindowSize = __webpack_require__(8137);
;// CONCATENATED MODULE: ./components/cards/DarkCard.tsx







var PillLocation;
(function(PillLocation) {
    PillLocation["Border"] = "-translate-y-[15px]";
    PillLocation["Inside"] = "p-8";
})(PillLocation || (PillLocation = {}));
var CheckInfo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        src: "/img/CheckInfoCard.svg",
        width: 20,
        height: 20,
        alt: "CheckInfo"
    });
};
var DarkCard = function(param) {
    var _reverseOrder = param.reverseOrder, reverseOrder = _reverseOrder === void 0 ? true : _reverseOrder, imgDesktop = param.imgDesktop, imgMobile = param.imgMobile, pillTitle = param.pillTitle, titleTwo = param.titleTwo, titleOne = param.titleOne, content = param.content, features = param.features;
    var width = (0,useWindowSize/* default */.Z)().width;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isMobile = ref[0], setIsMobile = ref[1];
    (0,react.useEffect)(function() {
        setIsMobile(width <= 768);
    }, [
        width
    ]);
    var finalReverseOrder = !isMobile && reverseOrder;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative mx-4 h-full max-w-[1120px] rounded-[16px] bg-primary-hover ".concat(isMobile ? "flex flex-col" : "grid md:grid-cols-2", " ").concat(finalReverseOrder ? "md:grid-cols-2-reverse md:grid-rows-[auto,1fr]" : "md:grid-rows-[1fr,auto]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex flex-grow flex-col items-start justify-between pl-9 pt-9 md:items-center md:pl-0 md:pt-9 ".concat(finalReverseOrder ? "order-2 md:order-1" : "order-1 md:order-2"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-start px-4 md:items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(animateWhileInView_ScrollMotion100Once, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill/* default */.ZP, {
                                    children: pillTitle
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(animateWhileInView_ScrollMotion100Once, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "block pt-6 text-left font-gt-haptik text-heading-3-mobile font-bold text-white md:text-center md:text-heading-3",
                                    children: titleOne
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(animateWhileInView_ScrollMotion100Once, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "-mt-4 block bg-accent-main bg-clip-text text-left font-gt-haptik text-heading-3-mobile text-transparent md:text-center md:text-heading-3",
                                    children: titleTwo
                                })
                            })
                        ]
                    }),
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex max-h-[300px] flex-shrink flex-grow justify-end overflow-clip rounded-lg md:flex",
                        children: imgDesktop
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "my-auto px-[52px] py-4 md:py-12  ".concat(finalReverseOrder ? "order-1 md:order-2" : "order-2 md:order-1"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: content
                    }),
                    features.map(function(feature, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex-2 flex w-full pt-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex-shrink-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckInfo, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "pl-2",
                                    children: feature
                                })
                            ]
                        }, index);
                    })
                ]
            }),
            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-shrink-0 items-center justify-center ".concat(finalReverseOrder ? "order-1 md:order-2" : "order-2 md:order-1"),
                children: imgMobile
            })
        ]
    });
};
/* harmony default export */ var cards_DarkCard = (DarkCard);

// EXTERNAL MODULE: ./components/UI/ViewDealsButton.tsx
var ViewDealsButton = __webpack_require__(98122);
;// CONCATENATED MODULE: ./components/sections/FooterCTA.tsx




var WordState;
(function(WordState) {
    WordState[WordState["forward"] = 0] = "forward";
    WordState[WordState["backward"] = 1] = "backward";
})(WordState || (WordState = {}));
function useOnScreen(ref) {
    var _$ref = (0,react.useState)(false), isOnScreen = _$ref[0], setIsOnScreen = _$ref[1];
    var observerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        observerRef.current = new IntersectionObserver(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
            return setIsOnScreen(entry.isIntersecting);
        });
    }, []);
    (0,react.useEffect)(function() {
        var _$ref;
        (ref === null || ref === void 0 ? void 0 : ref.current) && (observerRef === null || observerRef === void 0 ? void 0 : (_$ref = observerRef.current) === null || _$ref === void 0 ? void 0 : _$ref.observe(ref.current));
        return function() {
            var _$ref;
            observerRef === null || observerRef === void 0 ? void 0 : (_$ref = observerRef.current) === null || _$ref === void 0 ? void 0 : _$ref.disconnect();
        };
    }, [
        ref
    ]);
    return isOnScreen;
}
var TypingEffect = function() {
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(""), text = ref1[0], setText = ref1[1];
    var ref2 = (0,react.useState)(0), currentIndex = ref2[0], setCurrentIndex = ref2[1];
    var ref3 = (0,react.useState)(0), charPosition = ref3[0], setCharPosition = ref3[1];
    var ref4 = (0,react.useState)(WordState.forward), wordState = ref4[0], setWordState = ref4[1];
    var messages = (0,react.useMemo)(function() {
        return [
            "As a toy ",
            "On drinks packaging "
        ];
    }, []);
    var isVisible = useOnScreen(ref);
    (0,react.useEffect)(function() {
        if (!isVisible) return;
        var timer = setTimeout(function() {
            if (currentIndex < messages.length) {
                var currentMessage = messages[currentIndex];
                setText(function(prevText) {
                    return wordState === WordState.forward ? prevText + currentMessage.charAt(prevText.length) : currentMessage.slice(0, -1 + charPosition);
                });
                setCharPosition(function(prevPos) {
                    return wordState === WordState.forward ? prevPos += 1 : prevPos -= 1;
                });
                if (text.length === currentMessage.length && wordState === WordState.forward) {
                    setWordState(WordState.backward);
                }
                if (text.length === 0 && wordState === WordState.backward) {
                    setWordState(WordState.forward);
                    setText("");
                    setCurrentIndex(function(index) {
                        return index += 1;
                    });
                }
            } else {
                setCurrentIndex(0);
            }
        }, 90);
        return function() {
            clearTimeout(timer);
        };
    }, [
        text,
        currentIndex,
        messages,
        wordState,
        charPosition,
        isVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mx-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: ref,
            className: "mx-auto mb-6 flex w-full max-w-[1120px] grow flex-col items-center justify-center rounded-3xl bg-[url('/img/FooterCTAMobile.png')] bg-cover bg-center bg-no-repeat md:bg-[url('/img/footerCTA.png')]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex w-full grow flex-col items-center justify-center py-32 md:py-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center justify-center space-y-2 p-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "mb-4 font-gt-haptik text-heading-4-mobile text-white md:text-heading-3",
                            children: "Imagine your NFT"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "bg-gradient-to-b from-uniqueFade-light via-uniqueFade-mid to-uniqueFade-dark bg-clip-text pb-1 text-center font-gt-haptik text-heading-4-mobile text-transparent md:text-heading-3",
                            children: [
                                text,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "opacity-0",
                                    children: "|"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewDealsButton/* default */.Z, {})
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var FooterCTA = (TypingEffect);

;// CONCATENATED MODULE: ./components/sections/AboutContent.tsx





var AboutContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-16 md:mb-36",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center gap-y-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_DarkCard, {
                        imgDesktop: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/img/forHoldersDesktop.png",
                            width: 500 / 1.5,
                            height: 340 / 1.5,
                            objectFit: "contain",
                            alt: "For Holders Image"
                        }),
                        imgMobile: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/img/ForHoldersMobile.png",
                            width: 500 / 1.5,
                            height: 500 / 1.5,
                            alt: "For Holders Image"
                        }),
                        pillTitle: "For holders",
                        titleOne: "Make your NFTs",
                        titleTwo: "Influential.",
                        content: "Unlock the full potential of your NFT with brand licensing. Elevate the recognition and impact of your NFT by capitalizing on its inherent value and granting licenses to renowned brands for product or media incorporation.",
                        features: [
                            "Accrue influence and recognition with your NFT",
                            "Partner with brands you love",
                            "Quick, clear, and simple guided Web3 licensing processes", 
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_DarkCard, {
                        imgDesktop: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/img/collections.png",
                            width: 800 / 1.5,
                            height: 344 / 1.5,
                            objectFit: "contain",
                            alt: "Collections Image"
                        }),
                        imgMobile: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/img/collectionsMobile.png",
                            width: 685 / 1.5,
                            height: 277 / 1.5,
                            alt: "Collections Image",
                            className: "rounded-[16px]"
                        }),
                        reverseOrder: false,
                        pillTitle: "Collections",
                        titleOne: "Build Awareness",
                        titleTwo: "For Your Collection",
                        content: // eslint-disable-next-line quotes
                        "Supercharge your NFT collection's global visibility beyond the realm of Web3 through licensing. Each licensed NFT acts as a powerful catalyst, amplifying the reach and unlocking unparalleled growth for your collection.",
                        features: [
                            "Licensed NFTs build awareness and visibility for your community",
                            "Grow your audience worldwide",
                            "Increase collection and holder value through IP monetization",
                            "Increase holder utility without airdrops", 
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_DarkCard, {
                        imgDesktop: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/img/forBrandsDesktop.png",
                            width: 849 / 1.5,
                            height: 466 / 1.5,
                            objectFit: "contain",
                            alt: "for Brands image"
                        }),
                        imgMobile: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/img/forBrandsMobile.png",
                            width: 600 / 1.5,
                            height: 510 / 1.5,
                            alt: "for Brands image",
                            className: "rounded-[16px]"
                        }),
                        pillTitle: "For Brands",
                        titleOne: "Mutually Beneficial",
                        titleTwo: "Licensing Partnerships",
                        content: "Discover a seamless and efficient path to partnering with Web3 collections and acquiring the ideal intellectual property (IP) that perfectly aligns with your campaigns, all at a reasonable price.",
                        features: [
                            "Find the best digital assets and Web3 communities that align with the needs of your campaign",
                            "Be a part of the Web3 digital ecosystem",
                            "Get valuable IP for reasonable prices", 
                        ]
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pt-16 md:pt-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterCTA, {})
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/sections/AboutHero.tsx



var AboutHero = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative h-[calc(100dvh)] w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute left-0 top-0 h-[calc(100dvh)] min-h-[500px] w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/img/hero.png",
                    layout: "fill",
                    alt: "hero image background"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute left-0 top-0 flex h-[calc(100dvh)] min-h-[500px] w-full flex-col items-center justify-center p-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex max-w-lg flex-col items-center justify-center md:max-w-3xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "enter-el-block bg-gradient-to-b from-uniqueFade-light via-uniqueFade-mid to-uniqueFade-dark bg-clip-text text-center font-gt-haptik text-heading-1-mobile text-transparent md:text-heading-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "leading-none",
                                children: "About"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "-mt-8",
                                children: "OverpassIP"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var sections_AboutHero = (AboutHero);

// EXTERNAL MODULE: ./hooks/usePageEntrance.ts
var usePageEntrance = __webpack_require__(7414);
// EXTERNAL MODULE: ./styles/Home.module.css
var Home_module = __webpack_require__(26724);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
;// CONCATENATED MODULE: ./pages/about.tsx








var About = function() {
    (0,usePageEntrance/* usePageEntrance */.s)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoHead/* default */.Z, {
                title: "OverpassIP",
                description: "Most people don’t have the resources, time, or connections to truly use\n        their web3 IP. Our goal at OverpassIP is to provide holders with easily\n        accessible opportunities to leverage their NFT’s IP. With OverpassIP,\n        the Web3 user will seamlessly connect with the Web2 brand. Join us in\n        revolutionizing IP functionality for years to come."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: (Home_module_default()).main,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {
                    heroSection: /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_AboutHero, {}),
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutContent, {})
                })
            })
        ]
    });
};
/* harmony default export */ var about = (About);


/***/ }),

/***/ 26724:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__bCOhY","main":"Home_main__nLjiQ","footer":"Home_footer____T7K","card":"Home_card___LpL1","logo":"Home_logo__27_tb","grid":"Home_grid__GxQ85","code":"Home_code__suPER"};

/***/ }),

/***/ 66383:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(33579);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(15459);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(55247); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);